<script>
    export let visible = false
    export let duration = 250
    export let delay = 0
    export let style = ''
    import { sineInOut } from 'svelte/easing'
    import blur from '../../custom/animations/blur'
</script>

{#if visible}
    <div
        {style}
        class="modalBlur"
        transition:blur={{ duration, delay, easing: sineInOut }}
    >
        <slot />
    </div>
{/if}

<style>
    .modalBlur {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: fixed;
        top: 0;
        z-index: var(--lvl-2);
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(32, 37, 43, 0.6);
        backdrop-filter: blur(15px);
        /* animation: popup .2s ease-in-out;
    animation-fill-mode: backwards; */
    }
</style>
